const defaultsDeep = (map, ...sources) => map
    .mergeDeepWith(
        (prev, next) => (prev === undefined ? next : prev),
        ...sources
    );

export default defaultsDeep;
